export default __webpack_public_path__ + "static/media/0574.1e5962a2.jpg";